import Pricer from '@yupwego/pricer';
import classnames from 'classnames';
import css from 'styled-jsx/css';
import PropTypes from 'prop-types';
import Card from '../common/layout/Card.js';
import { fonts, colors } from '../common/Theme';
import { formatter } from '@yupwego/string-fns';

const BREAKPOINT = '680px';
const styles = css`
  .description-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
  }

  @media (min-width: ${BREAKPOINT}) {
    .description-list {
      align-items: center;
      text-align: center;
      min-width: 25%;
      flex-direction: row;
      justify-content: space-evenly;
    }
  }
  .description-container {
    flex-grow: 1;
    max-width: 100%;
    margin-bottom: 10px;
  }
  .details-name {
    min-width: 25%;
    max-width: 100%;
    font-family: ${fonts.primaryFont};
    font-size: 1.4rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 15px;
  }
  .description-title {
    font-size: 1rem;
    margin-bottom: 8px;
  }
  .description-details {
    font-size: 1rem;
    font-weight: bold;
    margin-left: 0;
  }
  .description-years {
    font-weight: normal;
  }
`;

const travelerStyles = css.resolve`
  .traveler-profile {
    align-items: center;
    padding: 18px 12px;
    border-radius: 16px;
    box-shadow: 0px 0px 16px 0px ${colors.warmGrey15};
  }

  @media (min-width: ${BREAKPOINT}) {
    .traveler-profile {
      justify-content: center;
      padding: 32px 42px;
    }
  }
`;

const Traveler = ({ traveler }) => {
  const travelerAge = Pricer.getAge(traveler);
  return (
    <>
      <Card
        className={classnames('traveler-profile', travelerStyles.className)}
        plane
      >
        <div className="details-name">
          {`${traveler.firstname} ${traveler.lastname}`}
        </div>
        <dl className="description-list">
          <div className="description-container">
            <dt className="description-title">Date de naissance</dt>
            <dd className="description-details">
              {formatter(traveler.birthday)}
              <span className="description-years"> - {travelerAge} ans</span>
            </dd>
          </div>
          <div className="description-container">
            <dt className="description-title">Adresse mail</dt>
            <dd className="description-details">{traveler.email}</dd>
          </div>
          <div className="description-container">
            <dt className="description-title">Pays de résidence</dt>
            <dd className="description-details">{traveler.country}</dd>
          </div>
        </dl>
      </Card>
      <style jsx>{styles}</style>
      {travelerStyles.styles}
    </>
  );
};

Traveler.propTypes = {
  traveler: PropTypes.object.isRequired
};

export default Traveler;
